@if (isSectionVisible) {
<ppl-accordion [title]="'Invoice Summary'" [isOpen]="true">
  <p class="message">
    Please use the filters to view in-process invoices.
  </p>
  <div class="">
    <div class="">
      <form nz-form [formGroup]="inProcessInvoiceSearchForm">
        <nz-row [nzGutter]="16">
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a service date'">
                <ppl-date-picker formControlName="serviceDate" [id]="'inProcessServiceDate'" [showIcon]="true"
                  [placeholder]="'Service Date'" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'"
                  [iconDisplay]="'input'" [ariaLabel]="'Service Date'"
                  [panelStyleClass]="'custom-calendar-panel'">
                </ppl-date-picker>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="5" [nzXXl]="5">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a provider'">
                <nz-select formControlName="paName" class="ppl-select filters" id="paName"
                  nzPlaceHolder="Provider" nzShowSearch nzAllowClear style="width: 100%;">
                  @for(opt of providers; track $index){
                  <nz-option [nzLabel]="opt.providerFullName" [nzValue]="opt.providerId"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a status'">
                <nz-select formControlName="status" class="ppl-select filters" id="status" nzPlaceHolder="Status"
                  nzShowSearch nzAllowClear style="width: 100%;">
                  @for(opt of inProcessFilterStatus; track $index){
                  <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="" [nzXs]="12" [nzSm]="12" [nzMd]="12" [nzLg]="5" [nzXl]="4" [nzXXl]="4">
            <div class="invoice-action-buttons">
              <ppl-button label="Search" icon="fa fa-filter" [styleString]="'margin-top: -2px;'" customClass="primary-button"
                [iconPosition]="'left'" (click)="inProcessTimesheetSearch()"
                *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'read']"></ppl-button>
              <ppl-button label="" ariaLabel="Refresh" icon="fa fa-refresh" customClass="primary-button"
                [iconPosition]="'left'" (click)="refreshInProcessInvoices()"></ppl-button>
            </div>
          </nz-col>
        </nz-row>
      </form>
    </div>
  </div>
  <ppl-accordion [title]="'In-Process Invoices'" [isOpen]="true">
    @if(inprocessInvoices.length > 0){
    <ppl-list-table #inProcessInvoiceChildComponent class="in-process"
      [customDataLoaded]="true" [disableSort]="false"
      [disableSearch]="true" [showCustomSearch]="false" [enableActions]="true" [disableSelection]="true"
      [actionButtons]="actionButtonsInProcess" [data]="inprocessInvoices"
      [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden"
      (gridAction)="onAction($event)" [pagination]="true" [loadPage]="true" [recordsPerPage]="10" [from]="'claims'" [cols]="cols"
      [cellClassResolver]="serviceDatesCellClassResolver"
      (onPageLoad)="onInProcessInvoicePageLoad($event)">
    </ppl-list-table>
    }@else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
    }
  </ppl-accordion>
  <p class="message">
    Please use the filters to view previous pay periods.
  </p>
  <div class="">
    <div class="">
      <form nz-form [formGroup]="invoiceSearchForm">
        <nz-row [nzGutter]="16">
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a service date'">
                <ppl-date-picker formControlName="serviceDate" [id]="'processedServiceDate'" [showIcon]="true"
                  [placeholder]="'Service Date'" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'"
                  [iconDisplay]="'input'" [ariaLabel]="'Service Date'"
                  [panelStyleClass]="'custom-calendar-panel'">
                </ppl-date-picker>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a pay period'">
                <nz-select formControlName="payPeriod" class="filters" id="payPeriod" nzPlaceHolder="Pay Period"
                  nzShowSearch nzAllowClear style="width: 100%;">
                  @for(opt of payPeriod; track $index){
                  <nz-option [nzLabel]="opt.payPeriod" [nzValue]="opt.payrollId"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a provider'">
                <nz-select formControlName="provider" class="ppl-select filters" id="provider"
                  nzPlaceHolder="Provider" nzShowSearch nzAllowClear style="width: 100%;">
                  @for(opt of providers; track $index){
                  <nz-option [nzLabel]="opt.providerFullName" [nzValue]="opt.providerId"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
            <nz-form-item>
              <nz-form-control [nzErrorTip]="'Please select a status'">
                <nz-select formControlName="status" class="ppl-select filters" id="status" nzPlaceHolder="Status"
                  nzShowSearch nzAllowClear style="width: 100%;">
                  @for(opt of status; track $index){
                  <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="" [nzXs]="12" [nzSm]="12" [nzMd]="12" [nzLg]="5" [nzXl]="4" [nzXXl]="4">
            <div class="invoice-action-buttons">
              <ppl-button label="Search" icon="fa fa-filter" [styleString]="'margin-top: -2px;'" customClass="primary-button"
                [iconPosition]="'left'" (click)="search()"
                *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'read']"></ppl-button>
              <ppl-button label="" ariaLabel="Refresh" icon="fa fa-refresh" customClass="primary-button"
                [iconPosition]="'left'" (click)="refreshProcessedInvoices()"></ppl-button>
            </div>
          </nz-col>
        </nz-row>
      </form>
    </div>
  </div>
  <ppl-accordion [title]="'Processed Invoices'" [isOpen]="true">
    @if(processedInvoices.length > 0){
    <ppl-list-table #completedInvoiceChildComponent
      [customDataLoaded]="true" [disableSort]="false" [disableSearch]="true" [showCustomSearch]="false"
      [enableActions]="true" [disableSelection]="true" [actionButtons]="actionButtonsProcessed" [data]="processedInvoices"
      [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden"
      (gridAction)="onAction($event)" [pagination]="true" [loadPage]="true" [recordsPerPage]="10" [cols]="processedInvoiceColumns" [from]="'claims'"
      [cellClassResolver]="serviceDatesCellClassResolver"
      (onPageLoad)="onCompletedInvoicePageLoad($event)">
    </ppl-list-table>
    }@else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
    }
  </ppl-accordion>
</ppl-accordion>
}

<div class="filter-panel">
  <ng-template #addInvoiceDialog let-cancel="cancel">
    <ppl-add-invoice [providerId]="rowData?.providerId" [mode]="'actions'" [provider]="providerData" [invoiceId]="rowData?.invoiceHeaderId" [consumerId]="rowData?.consumerId"
      (invoiceSaved)="handleCancel($event)" (cancel)="handleCancel($event)" (invoiceUpdated)="handleInvoiceUpdated($event)" [isReadOnly]="isReadOnly" [canApproveReject]="canApproveReject"></ppl-add-invoice>
  </ng-template>
</div>

<div class="filter-panel">
  <ng-template #denyDialog let-cancel="cancel">
    <p>Reason: </p>
    <nz-select nzPlaceHolder="Select a Reason" [(ngModel)]="selectedReason" style="width:100%; margin-bottom: 16px"
      nzShowArrow>
      @for(item of listOfOption; track $index ){
      <nz-option [nzLabel]="item" [nzValue]="item"></nz-option>
      }
    </nz-select>
  </ng-template>
</div>
